import { useEffect, useState } from "react";
import { Container } from "../../../../../common/components/container/Container";
import {
  useOperationFoldersListState,
  useOperationFoldersStore,
} from "../../../store/OperationFoldersStore";
import OperationFolderCard from "./components/OperationFolderCard";
import { ActionsKey } from "../../../../../common/models/Actions";
import { OperationFoldersService } from "../../../core/_request";
import { HttpStatusCode } from "axios";
import { useParams } from "react-router";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { CustomButton } from "../../../../../common/components/CustomButton/CustomButton";
import { Assets } from "../../../../../assets";
import OperationFoldersForm from "./components/OperationFoldersForm";
import { OperationFoldersContext } from "../../../core/_context";
import { TitleHeader } from "../../../../../common/components/TitleHeader/TitleHeader";

function OperationFolders() {
  const {
    setOperationFoldersList,
    operationFoldersList,
    actioned,
    setActioned,
  } = useOperationFoldersStore();
  const { pageState, resetPageState } =
    useOperationFoldersListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { id } = useParams();

  useEffect(() => {
    id && fetchAllOperationFolders(id, pageState);
  }, [id, pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (folder: any, action: ActionsKey) => {
    setActioned({ action, data: folder });
    setIsShowForm(true);
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  console.log("actioned: ", actioned?.data);

  /*     const getOne = async (id: number, action: any) => {
      try {
        setIsLoading(true);
        const res = await ActivityService.getActivityById(id);
        if (res?.status === HttpStatusCode.Ok) {
          setActioned({
            data: {
              ...res?.data,
            },
            action,
          });
        }
        onShowAddHandler();
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }; */

  /*     const onDeleteHandler = async (id: number) => {
      try {
        setIsLoading(true);
        const res = await ActivityService.deleteActivity(id);
        if (res?.status === HttpStatusCode.NoContent) {
          fetchAllOperationFolders();
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }; */

  const fetchAllOperationFolders = async (id: string, params?: any) => {
    try {
      setIsLoading(true);
      const res = await OperationFoldersService.getFolders(id, params);
      if (res?.status === HttpStatusCode.Ok) {
        setOperationFoldersList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
  };

  return (
    <OperationFoldersContext.Provider value={operationFoldersList}>
      {/* <GoBack /> */}
      <TitleHeader isSHowBack title="" />

      <Loader isLoading={isLoading} />
      <Container>
        <CustomButton
          className="ms-auto d-flex align-items-center gap-2 px-3 py-2"
          onClick={onShowAddHandler}
        >
          <div className="">
            <img src={Assets.iconsSvg.addBox} alt=""/>
          </div>
          {"Ajouter un fichier"}
        </CustomButton>
        {operationFoldersList?.map((folder: any) => {
          return (
            <OperationFolderCard
              title={folder?.name}
              countMediaFiles={
                folder?.countMediaFiles > 1
                  ? folder?.countMediaFiles
                  : undefined
              }
              onClick={() => onActionClick(folder, "update")}
            />
          );
        })}
      </Container>
      {isShowForm && (
        <CustomDrawer
          title={actioned?.action === "update" ? "Détails" : "Nouveau"}
          isOpen={isShowForm}
          onClose={onShowAddHandler}
        >
          <OperationFoldersForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      )}
    </OperationFoldersContext.Provider>
  );
}

export default OperationFolders;
